export default "__VITE_ASSET__a19765ea__"